import { render, staticRenderFns } from "./mySubmissionsHeader.vue?vue&type=template&id=25809c9a&scoped=true&"
import script from "./mySubmissionsHeader.vue?vue&type=script&lang=js&"
export * from "./mySubmissionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./mySubmissionsHeader.vue?vue&type=style&index=0&id=25809c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25809c9a",
  null
  
)

export default component.exports